import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export default function GoogleAIStudioLoginDialog({ service, onClose, onSaved }) {
  const [view, setView] = useState(null);
  const [busy, setBusy] = useState(false);
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const profile = service.profile;
  const action = async (body) => {
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/browser/profiles/${encodeURIComponent(profile)}/manual`, body, { timeout: 45000 });
      if (data.saved) {
        toast.success("Sesión de Google guardada"); onSaved(); onClose();
      } else if (data.image_b64) setView(data);
    } catch (e) { setError(apiErrorMessage(e)); }
    finally { setBusy(false); }
  };
  useEffect(() => { action({ action: "start" }); }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps
  const close = () => {
    api.post(`/browser/profiles/${encodeURIComponent(profile)}/manual`, { action: "close" }).catch(() => {});
    setText(""); onClose();
  };
  return <Dialog open onOpenChange={(open) => !open && close()}>
    <DialogContent className="bg-zinc-950 border-zinc-800 w-[95vw] max-w-6xl max-h-[95vh] overflow-y-auto">
      <DialogHeader><DialogTitle>Iniciar sesión en Google AI Studio · {profile}</DialogTitle></DialogHeader>
      <p className="text-sm text-zinc-400">Este navegador pertenece solo a este perfil. Pulsa el campo de Google AI Studio en la imagen, escribe abajo y pulsa «Introducir texto». Completa tú el acceso y cualquier verificación.</p>
      <div className="flex flex-wrap gap-2 items-center">
        <Button size="sm" variant="outline" disabled={busy} onClick={() => action({ action: view ? "view" : "start" })}>{busy ? "Cargando…" : "Actualizar vista"}</Button>
        <span className="text-xs text-zinc-400">{view?.host || "accounts.google.com"}</span>
        <Button size="sm" className="ml-auto" disabled={busy || !view} onClick={() => action({ action: "save" })}>Guardar sesión</Button>
      </div>
      {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
      {view && <img alt="Navegador privado de Google AI Studio: pulsa para interactuar" draggable={false}
        className={"w-full rounded border border-zinc-700 " + (busy ? "opacity-60 pointer-events-none" : "cursor-pointer")}
        src={`data:image/jpeg;base64,${view.image_b64}`}
        onClick={(e) => { const r = e.currentTarget.getBoundingClientRect(); action({ action: "click", x: Math.floor((e.clientX-r.left)*view.width/r.width), y: Math.floor((e.clientY-r.top)*view.height/r.height) }); }} />}
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); if (!text || busy) return; const value=text; setText(""); action({ action:"type", text:value }); }}>
        <Input type="password" autoComplete="off" maxLength={1000} aria-label="Texto para el campo seleccionado de Google AI Studio" placeholder="Usuario, contraseña o código para el campo seleccionado" value={text} onChange={(e) => setText(e.target.value)} />
        <Button type="submit" disabled={busy || !view || !text}>Introducir texto</Button>
      </form>
      <div className="flex flex-wrap gap-2">
        {[["Enter","Continuar / Enter"],["Tab","Siguiente campo"],["Control+A","Seleccionar todo"],["Backspace","Borrar"],["Escape","Esc" ]].map(([key,label]) => <Button key={key} size="sm" variant="outline" disabled={busy || !view} onClick={() => action({ action:"key",key })}>{label}</Button>)}
        <Button size="sm" variant="outline" disabled={busy || !view} onClick={() => action({ action:"scroll",direction:"down" })}>Bajar</Button>
        <Button size="sm" variant="outline" disabled={busy || !view} onClick={() => action({ action:"scroll",direction:"up" })}>Subir</Button>
        <Button size="sm" variant="ghost" disabled={busy} onClick={close}>Cerrar acceso manual</Button>
      </div>
      <p className="text-xs text-zinc-500">La contraseña se envía al campo seleccionado del navegador y no se guarda en KRAI Connect. Solo se conserva la sesión cuando pulses «Guardar sesión». Completa el acceso de Google hasta ver AI Studio. Guardar la sesión no activa permisos de generación ni facturación.</p>
    </DialogContent>
  </Dialog>;
}
